import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Divider, Row, SizedBox } from "../CommonBaseComponents";
import { C3Text } from "../text/CustomText";
import CustomIcon from "../image/CustomIcon";
import { useClickOutside } from "../../hooks/useClickOutside";
import { ScrollDropdownWrapper } from "./CustomDropdownWrapper";
import { Theme } from "../../Theme";

function CustomDropdownMenu({
    onClose,
    values,
    onSelect,
    currentValue,
    noDivider = false,
    noBlur = false,
    anchorEl,
    placement = "bottom-start",
}) {
    const menuRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });

    useClickOutside(menuRef, (event) => {
        if (anchorEl && anchorEl.contains(event.target)) return;
        onClose();
    });

    useEffect(() => {
        const updatePosition = () => {
            if (anchorEl) {
                const rect = anchorEl.getBoundingClientRect();
                let leftPos;

                if (placement === "bottom-end") {
                    leftPos = rect.right - rect.width;
                } else {
                    leftPos = rect.left;
                }

                setPosition({
                    top: rect.bottom,
                    left: leftPos,
                    width: rect.width,
                });
            }
        };

        updatePosition();

        window.addEventListener("scroll", updatePosition, true);
        window.addEventListener("resize", updatePosition);

        return () => {
            window.removeEventListener("scroll", updatePosition, true);
            window.removeEventListener("resize", updatePosition);
        };
    }, [anchorEl, placement]);

    const applyValue = (value) => {
        onSelect(value);
        onClose();
    };

    const dropdownContent = (
        <ScrollDropdownWrapper
            ref={menuRef}
            $noBlur={noBlur}
            $top={position.top}
            $left={position.left}
            $width={position.width}
        >
            {values.map((value, index) => (
                <SizedBox
                    key={value.value}
                    width={"100%"}
                    height={"auto"}
                    hoverBackgroundColor={Theme.color.zinc150}
                    borderRadius={"4px"}
                    onClick={() => applyValue(value.value)}
                    cursor={"pointer"}
                    minHeight={"40px"}
                >
                    <Row justifyContent={"space-between"} padding={"10px 20px"} cursor={"pointer"} width={"100%"}>
                        <C3Text fontColor={value.color ?? Theme.color.zinc850}>{value.label}</C3Text>
                        {currentValue === value.value && <CustomIcon iconName={"checked_active"} size={"15.5px"} />}
                    </Row>
                    {index < values.length - 1 && !noDivider && <Divider />}
                </SizedBox>
            ))}
        </ScrollDropdownWrapper>
    );

    return createPortal(dropdownContent, document.body);
}

export default CustomDropdownMenu;
